import React from 'react';

import QuotaSupervisor  from 'components/Tvendo/Sale/QuotaBPartner/Verdum/QuotaSupervisor/List.js';

export default function () {
  return <QuotaSupervisor  />;
}